import { getExistingApiInstance } from '@/api/api-instance'

export { getExistingApiInstance }
